import { render, staticRenderFns } from "./FeaturedGame.vue?vue&type=template&id=3bc7b374"
import script from "./FeaturedGame.vue?vue&type=script&lang=js"
export * from "./FeaturedGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports